import contentBg from "../assets/img/content_bg.png";

// -- css -- //
import "../css/ContentHeader.css";

function Content(props) {
  return (
    <>
      <div className='content_title'>
        <img src={contentBg} alt='메인배경' />
        <h2 className='heading1'>{props.title}</h2>
        <h3 className='heading1'>{props.title1}</h3>
      </div>
    </>
  );
}

export default Content;
